import { Box, IconButton, TextField, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { useState } from "react";
import { useRequest } from "../../api/utils/useRequest";
import { AccountAPIs, BalootUserAPIs, BalootUserV2APIs } from "../../api/APIs";
import { useDispatch } from "react-redux";
import { setIsSynced } from "../../store/actions/AuthActions";
import ArrowForward from "@mui/icons-material/ArrowForward";
import PasswordTextField from "../../components/shared/PasswordTextField";
import { LoadingButton } from "@mui/lab";
import CheckValidRow from "../../components/shared/CheckValidRow";
import { setConfig } from "../../store/actions/ConfigActions";

function ConfirmPasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = location.state.mobile;
  const [password] = useOutletContext();

  const { apiCall: setPassword, loading: passwordLoading } = useRequest(
    AccountAPIs.setPassword
  );
  const { apiCall: sync, loading: syncLoading } = useRequest(
    BalootUserV2APIs.sync
  );

  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = () => {
    setPassword({
      data: { mobile: mobile, password: password },
      onSuccess: (response) => {
        localStorage.setItem("accessToken", response.access_token);
        localStorage.setItem("refreshToken", response.refresh_token);
        sync({
          onSuccess: (response) => {
            dispatch(setIsSynced(true));
            dispatch(setConfig({ config: response }));
            if (response.sejamInfo.status === "AUTHENTICATED") {
              navigate("/app", { replace: true });
            } else if (!response.personalInfo.nationalId) {
              navigate("/auth/national-id", { replace: true });
            } else if (
              !response.personalInfo.firstName &&
              !response.personalInfo.lastName
            ) {
              navigate("/auth/personal-info/first-name", { replace: true });
            } else {
              navigate("/app", { replace: true });
            }
          },
        });
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            ساخت حساب بلوط
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography variant="body2" color="grey.2">
            تکرار کلمه عبور
          </Typography>
          <PasswordTextField
            autoComplete="off"
            name="confirm-password"
            password={confirmPassword}
            setPassword={setConfirmPassword}
          />
          <CheckValidRow
            sx={{ my: "2px", mt: 2 }}
            isValid={password === confirmPassword}
            title="مطابق کلمه عبور در صفحه قبل"
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            mt: 1,
          }}
        >
          <Box>
            <LoadingButton
              onClick={handleSubmit}
              loading={syncLoading || passwordLoading}
              variant="contained"
              color="primary"
              disabled={password !== confirmPassword}
              sx={{ height: 56, width: 48 }}
            >
              <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default ConfirmPasswordPage;
